import { useEffect, useState } from "react";
import { PageProps } from "../_types/page.props.interface";
import useDocumentTitle from "../helpers/title.helper";
import { AcademyService } from "../services/academy.service";
import { useDispatch } from "react-redux";
import { Academy } from "../_types/academy.type";
import {
    Box,
    Button,
    Chip,
    CircularProgress,
    Container,
    Divider,
    IconButton,
    Pagination,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material'
import { StyleHelper } from "../helpers/styler-helper";
import { Formatters } from "../helpers/formatters";
import { Delete, OpenInBrowserOutlined, OpenInFull, OpenInNew } from "@mui/icons-material";
import AcademyModal from "../components/modal/academy-modal";
import { useNavigate } from "react-router-dom";

export default function AcademyPage(props: PageProps) {


    useDocumentTitle(props.title)
    const [isLoading, setIsLoading] = useState(true)
    const [page, setPage] = useState(1)
    const [loading, setLoading] = useState(true)
    const [academies, setAcademies] = useState<Academy[]>([])
    const [hasNextPage, setHasNextPage] = useState(false)
    const [hasPrevPage, setHasPrevPage] = useState(false)
    const [totalPages, setTotalPages] = useState(1)
    const [totalDocs, setTotalDocs] = useState(0)
    const [showModal, setShowModal] = useState(false)
    const [editingAcademy, setEditingAcademy] = useState<Academy | null>(null)
    const navigate = useNavigate()

    const dispatch = useDispatch()
    const academyService = new AcademyService(dispatch)


    useEffect(() => {
        _fetchAcademies(1)
    }, [])

    const _fetchAcademies = async (p: number) => {
        setLoading(true)
        setPage(p)

        const results = await academyService.searchAcademies(p)

        if (results?.docs) {
            setAcademies(results.docs)
            setHasNextPage(results.hasNextPage)
            setHasPrevPage(results.hasPrevPage)
            setTotalPages(results.totalPages)
            setTotalDocs(results.totalDocs)
        }
        setTimeout(() => {
            setLoading(false)
        }, 500)
    }


    return (
        <Container className='p-3'>
            <Box
                display={'flex'}
                justifyContent={'space-between'}
                alignItems={'baseline'}
            >
                <Box>
                    <Typography variant='h2' textAlign={'start'}>
                        Academies
                    </Typography>
                    <Typography variant='body1'>View, and create new academies</Typography>
                </Box>
                <Button
                    variant='contained'
                    color='success'
                    onClick={() => { setShowModal(true); setEditingAcademy(null) }}
                >
                    Create New Academy
                </Button>
            </Box>

            <Divider />

            <StyleHelper.VerticalSpace />
            {!loading && (
                <>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Start</TableCell>
                                    <TableCell>End</TableCell>
                                    <TableCell>Capacity</TableCell>
                                    <TableCell>Tickets Sold</TableCell>

                                    <TableCell align='right'></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {academies?.map(academy => (
                                    <TableRow
                                        key={academy.id}
                                        sx={{
                                            '&:last-child td, &:last-child th': { border: 0 },
                                            '&:nth-of-type(odd)': {
                                                backgroundColor: '#f2f2f2'
                                            }
                                        }}
                                    >
                                        <TableCell component='th' scope='row'>
                                            {academy.name}
                                        </TableCell>
                                        <TableCell>
                                            {Formatters.formateLocalTZ(academy.startDate)}
                                        </TableCell>
                                        <TableCell >
                                            {Formatters.formateLocalTZ(academy.endDate)}
                                        </TableCell>
                                        <TableCell >
                                            {Formatters.formateLocalTZ(academy.endDate)}
                                        </TableCell>
                                        <TableCell >
                                            {academy.ticketsSold ?? 0}/{academy.capacity}
                                        </TableCell>
                                        <TableCell align='right'>
                                            <IconButton aria-label='view' title='View Academy' onClick={() => { navigate(`/academy/${academy.id}`) }}>
                                                <OpenInNew />
                                            </IconButton>
                                            <IconButton aria-label='delete' title='Delete Academy' onClick={() => { }}>
                                                <Delete color="error" />
                                            </IconButton>


                                        </TableCell>
                                        {/* <TableCell align='right'>{alert.short}</TableCell>
                                        <TableCell align='right'>
                                            <Chip
                                                label={Formatters.removeHyphensAndUppercase(
                                                    alert.alertType
                                                )}
                                                icon={_getIcon(alert)}
                                            />
                                        </TableCell>
                                        <TableCell align='right'>
                                            {Formatters.formateLocalTZ(alert.created)}
                                        </TableCell>
                                        <TableCell align='right'>
                                            {alert.campaignId && (
                                                <IconButton aria-label='delete' title='View in Klaviyo' onClick={() => window.open(`https://www.klaviyo.com/campaign/${alert.campaignId}/reports/overview`, "_blank")}>
                                                    <Campaign />
                                                </IconButton>
                                            )}
                                        </TableCell> */}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <StyleHelper.VerticalSpace />
                    <Stack spacing={2} justifyContent='center' alignItems='center'>
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={(event: unknown, page: number) => {
                                _fetchAcademies(page)
                            }}
                            variant='outlined'
                            shape='rounded'
                        />
                    </Stack>
                </>
            )}
            {loading && <CircularProgress />}
            <AcademyModal show={showModal} initialAcademy={editingAcademy} onClose={() => {
                setShowModal(false)
                _fetchAcademies(1)
                setEditingAcademy(null)
            }} />

        </Container>
    )
}